import type {
  MemberLinkInfoResponse,
  MemberSendCodeRequest,
  MemberSendCodeResponse,
  MemberVerifyCodeRequest,
  MemberVerifyCodeResponse,
} from "@repo/shared/types";
import { get, post } from "../_client";

/**
 * QL-505 — the member-link landing page's (`/p/m/:token`) only unauthenticated
 * call: a stale/typo'd link fails fast with a friendly message instead of only
 * after a full auth round trip. `unavailableReason` is set when `valid` is false.
 */
export function getMemberLinkInfo(memberToken: string) {
  return get<MemberLinkInfoResponse>(`/public/flow/member/${memberToken}/info`);
}

export function sendMemberCode(memberToken: string, request: MemberSendCodeRequest) {
  return post<MemberSendCodeResponse>(
    `/public/flow/member/${memberToken}/send-code`,
    request satisfies MemberSendCodeRequest,
  );
}

export function verifyMemberCode(memberToken: string, request: MemberVerifyCodeRequest) {
  return post<MemberVerifyCodeResponse>(
    `/public/flow/member/${memberToken}/verify-code`,
    request satisfies MemberVerifyCodeRequest,
  );
}
